import mdast from 'mdast';

import { SerializeOptions } from '@lumapps/wrex/serialization/markdown/toMarkdown/types';

import type { LinkElement } from '../../types';

export const LINK_ELEMENTS: SerializeOptions['elements'] = {
    link: (link: LinkElement, children) => ({ type: 'link', url: link.href, children }) as mdast.Link,
};
